define('presentation/signup/presentationObjects/signupProfilePresentationObject',[],function() {
    return function(){
        let self = this;
        self.emailAddress = null;
        self.isEmailStepCompleted = null;
        self.firstName = null;
        self.lastName = null;
        self.mobileNumber = null;
        self.mobileNumberCountryCode = null;
        self.howDidYouHearAboutUs = null;
        self.howDidYouHearAboutUsOther = null;
        self.signupPhoneNumbers = null;
        self.signupNumberType = null;
    };
});
